import { z } from "zod";

export const descriptionSchema = z.string().trim().min(3, "Description must be at least 3 characters");